export default "__VITE_ASSET__C72xtucn__"